export const SET_BUNDLE_NUMBERS = 'SET_BUNDLE_NUMBERS'
export const RESET_BUNDLE_NUMBERS = 'RESET_BUNDLE_NUMBERS'
